<template>
    <modal title="手机验证" :show=show :onCancel=onCancel :onSure=onSure height='196'>
         <div class="check-phone" slot="content">
             <p class="tip">提示：为了您的账号安全重要操作时，请进行短信验证</p>
             <div class="">请先用绑定手机<span class="phone">{{mobile}}</span>发短信，然后点“确定”按钮</div>
             <div class="item">
                <div class="send-sms">
                    发短信：<b>VMSE01</b><br>
                    到号码：<b>1069&nbsp;0133&nbsp;5125</b>            
                </div>
                <div class="code-box">
                <p class="error-info" v-if=errorTip>{{errorTip}}</p>
                <p>短信费用由运营商收取。 <span class="unless" @click="toapeal">手机号换了，无法验证？</span></p>
                </div>
             </div>
         </div>
     </modal>
</template>
<script>
import { getSecurity } from '@/service/settingService'
import { getUserInfo } from '@/service/homeService'
import router from '@/router'
import utils  from '@/common/utils'
export default {
    name: 'checksms',
    data() {
        return {
            errorTip:'',
            show:true,
            mobile:''
        }
    },
    created(){
        getUserInfo().then(res=>{
            this.mobile=res.mobile
        })
    },
    methods:{
        toapeal(){
            this.show=false            
            router.push({name:'appeal',query:{step:1}})
        },
        onCancel(){
            this.show=false
        },
        onSure(){
            if(this.cb){
                this.cb().then(res=>{
                    if(res.status==428){
                        this.errorTip="我们未收到您发的短信，请编辑短信重发"
                    }else{
                        this.show=false
                    }
                })
            }
        }
    }
}
</script>
<style lang="scss" scoped>
.check-phone{
    text-align: left;
    padding:0 50px;
    font-size: 12px;
    .tip{
        color:#84848B;
        margin:22px 0 18px;
    }
    label{
        color:#333333;
    }
    input{
        width:120px;
        height:32px;
        border:1px solid #B8B8B8;
        color:#84848B;
        padding: 10px;
        &:hover{
            border:1px solid #505060;
            color:#434354;
        }
    }
    .item{
        margin-top:21px;
    }
    .send-sms{
        padding: 10px 20px;
        border: 1px solid #d19f4e;
        background-color: #f3d35533;
        border-radius: 2px;
        line-height: 2;
        color: #d19f4e;
    }
    .code-box{
        display: inline-block;
        vertical-align: top;
        // margin-left:14px;        
    }
    .error-info{
        font-size: 12px;
        color: #CC0000;
        text-align:left;
        margin:6px 0 10px;  
        height: 12px;          
    }
    .phone{
        color:#323237;
        margin:0 4px;
    }
    .unless{
        color:#D59334;
        cursor: pointer;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/modal/checksms.vue